var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-gaite-lyrique';
                    var viewUrl = 'sprite.svg#view-logo-gaite-lyrique';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-gaite-lyrique#logo-gaite-lyrique';
                            viewUrl = 'sprite.svg?logo-gaite-lyrique#view-logo-gaite-lyrique';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 222 110',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };